import { render, staticRenderFns } from "./CardOrderReviewData.vue?vue&type=template&id=5389234a"
import script from "./CardOrderReviewData.vue?vue&type=script&lang=js"
export * from "./CardOrderReviewData.vue?vue&type=script&lang=js"
import style0 from "./CardOrderReviewData.vue?vue&type=style&index=0&id=5389234a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports